var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStayTunedPhotos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 156,
    viewBox: "0 0 167 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0661 136.805L23.4329 137.597C20.4051 138.022 17.6056 135.913 17.1801 132.885L1.7705 23.2399C1.34498 20.2122 3.45451 17.4127 6.48227 16.9872L114.757 1.77019C117.785 1.34467 120.584 3.4542 121.01 6.48197C121.01 6.48197 121.995 13.4926 122.334 15.9041",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5641 130.701L27.4489 131.428C24.6995 131.819 22.1611 129.907 21.779 127.158L7.94541 27.6121C7.56341 24.8632 9.48252 22.318 12.2319 21.9273L110.55 7.95302C113.3 7.56225 115.838 9.47388 116.22 12.2228L117.409 20.7771C117.473 21.24 121.72 51.9648 130.15 112.951C130.573 116.014 128.461 118.843 125.433 119.272C125.401 119.276 125.368 119.28 125.336 119.284L32.5641 130.701Z",
    fill: "#FF9D2E",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0661 136.805L23.4329 137.597C20.4051 138.022 17.6057 135.913 17.1801 132.885L1.77051 23.2399C1.34498 20.2122 3.45452 17.4127 6.48228 16.9872L114.757 1.7702C117.785 1.34467 120.584 3.45421 121.01 6.48197C121.01 6.48197 121.995 13.4926 122.334 15.9041",
    stroke: "#FF9D2E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.488 22.2861L124.18 26.6049",
    stroke: "#FF9D2E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2449 26.3688C47.4181 24.721 48.8942 23.5256 50.542 23.6988L162.337 35.4489C163.985 35.6221 165.18 37.0983 165.007 38.7461L153.112 151.918C152.939 153.565 151.463 154.761 149.815 154.588L38.02 142.837C36.3723 142.664 35.1769 141.188 35.3501 139.54L47.2449 26.3688Z",
    fill: "white",
    stroke: "#FF9D2E",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4406 38.9601C57.6138 37.3124 59.0899 36.117 60.7377 36.2901L149.746 45.6453C151.394 45.8185 152.589 47.2946 152.416 48.9424L144.507 124.186C144.334 125.834 142.858 127.029 141.21 126.856L52.2021 117.501C50.5544 117.328 49.359 115.851 49.5322 114.204L57.4406 38.9601Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5382 96.3292L76.1881 86.4485C77.8217 85.3466 80.0144 85.5987 81.3555 87.0424L92.4229 98.9574C92.781 99.3429 93.3764 99.385 93.7852 99.0538L116.623 80.5483C118.471 79.051 121.21 79.4871 122.501 81.4843L137.243 104.286L139.227 107.597L138.244 119.234C138.196 119.795 137.696 120.206 137.137 120.144L57.5321 111.3C56.9905 111.24 56.5968 110.757 56.6467 110.214L57.7261 98.4917L61.5382 96.3292Z",
    fill: "#FF9D2E",
    fillOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4351 39.0647C58.5505 37.9661 59.5347 37.1692 60.6332 37.2847L149.641 46.6398C150.74 46.7553 151.537 47.7394 151.421 48.8379L143.513 124.081C143.397 125.18 142.413 125.977 141.315 125.861L52.3067 116.506C51.2081 116.391 50.4112 115.407 50.5267 114.308L58.4351 39.0647Z",
    stroke: "#FF9D2E",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78.5486,
    cy: 63.2117,
    r: 8.3042,
    transform: "rotate(6 78.5486 63.2117)",
    fill: "#FF9D2E",
    fillOpacity: 0.15,
    stroke: "#FF9D2E",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7544 98.4705C64.2025 94.7082 75.0987 87.1836 75.0987 87.1836C77.3597 85.6586 80.3945 86.0074 82.2505 88.0056L92.1791 98.6945C92.6746 99.228 93.4987 99.2863 94.0645 98.8279L115.295 81.6249C117.671 79.7 121.157 80.0653 123.082 82.4409C123.206 82.5944 123.322 82.7545 123.43 82.9204C123.43 82.9204 135.842 102.616 138.743 107.219",
    stroke: "#FF9D2E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStayTunedPhotos);
export default __webpack_public_path__ + "static/media/stay-tuned-photos.a9b44a1960eea162c7a4507cffd73929.svg";
export { ForwardRef as ReactComponent };